import { gql } from '@apollo/client';
import { ProductCategoryInfo } from '../fragments';

export default gql`
  query productCategory($id: ID) {
    productCategory(id: $id) {
      ...ProductCategoryInfo
    }
  }
  ${ProductCategoryInfo}
`;
